import { useCallback } from 'react';
import Button from '@mui/material/Button';
import { isEmpty } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';
import FileExport from '@gef-ui/material-icons/FileExport';

import { ComponentLoader } from 'components';
import { urls } from 'features/common/fetch/constants';
import { exportToCsv } from 'features/views/contactHistory/actions';
import { getCommunicationGroups } from 'features/views/contactHistory/selectors';

export const ActionButtons = () => {
	const dispatch = useDispatch();
	const communicationGroups = useSelector(getCommunicationGroups);

	const handleExportToCsv = useCallback(() => {
		dispatch(exportToCsv());
	}, [dispatch]);

	return (
		!isEmpty(communicationGroups) && (
			<ComponentLoader fetchStorePath={urls.communicationHistoryExport} ignoreErrors>
				<Button variant="text" size="small" startIcon={<FileExport />} onClick={handleExportToCsv}>
					{getLabelMessage('contactHistory:reportKH')}
				</Button>
			</ComponentLoader>
		)
	);
};

export default ActionButtons;
